import React from 'react'

export const PurchasingIcon = (): JSX.Element => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Shopping">
      <path
        id="Vector"
        d="M17.1436 5.53838H14.1078V5.18124C14.1078 2.91338 12.2686 1.0741 10.0007 1.0741C7.73284 1.0741 5.89356 2.91338 5.89356 5.18124V5.53838H2.85784C2.46275 5.53838 2.14355 5.85758 2.14355 6.25267V18.217C2.14355 18.612 2.46275 18.9312 2.85784 18.9312H17.1436C17.5386 18.9312 17.8578 18.612 17.8578 18.217V6.25267C17.8578 5.85758 17.5386 5.53838 17.1436 5.53838ZM7.5007 5.18124C7.5007 3.79954 8.619 2.68124 10.0007 2.68124C11.3824 2.68124 12.5007 3.79954 12.5007 5.18124V5.53838H7.5007V5.18124ZM16.2507 17.3241H3.7507V7.14553H5.89356V9.10981C5.89356 9.20803 5.97391 9.28838 6.07213 9.28838H7.32213C7.42034 9.28838 7.5007 9.20803 7.5007 9.10981V7.14553H12.5007V9.10981C12.5007 9.20803 12.5811 9.28838 12.6793 9.28838H13.9293C14.0275 9.28838 14.1078 9.20803 14.1078 9.10981V7.14553H16.2507V17.3241Z"
        fill="black"
      />
    </g>
  </svg>
)
